import React, {useEffect, useState} from "react";
import {StoryblokComponent} from "@storyblok/react";
import {FormattedMessage, useIntl} from "react-intl";
import {Helmet} from "react-helmet";
import {useParams} from "react-router-dom";
import {RichText} from "@commons/infra/storyblok/richText";
import Breadcrumbs from "@commons/ui/component/Breadcrumbs";
import {BackgroundWave2} from "@commons/uinew/domaincomponent/svg";
import {CenteredTextualContentLayout} from "@commons/uinew/layout/CenteredTextualContentLayout";
import {HeadingPlaceholder, MultipleParagraphsPlaceholder} from "@commons/uinew/component/placeholder";
import {LatvianMetaLinksHelmet} from "@commons/infra/i18n/MetaLinksHelmet";
import {extractImageDimensions, useSbDataFetcher} from "@commons/infra/storyblok/helpers";
import {PublicLinks} from "../../../../../../portal-latvia/src/utility/links";
import {title} from "@commons/shared";
import LocalizedLink from "@commons/infra/i18n/LocalizedLink";
import {useConfirmationModalControls} from "@commons/infra/component/ConfirmationModal";
import PromocodeGiveawayPopup from "@commons/ui/page/public/promotion/PromocodeGiveawayPopup";
import {AboutUsBanner} from "@commons/ui/page/public/promotion/AboutUsBanner";


let SpecificHealthIssueStoryblokPage = () => {
    let {locale} = useIntl()
    let params = useParams();
    let sbDataFetcher = useSbDataFetcher()
    let controls = useConfirmationModalControls()

    let [isLoading, setIsLoading] = useState(true)
    let [story, setStory] = useState()
    let [imgDimensions, setImgDimensions] = useState({})

    useEffect(() => {
        sbDataFetcher(`health-issues/${params.parentSlug}/${params['childSlug']}_${locale}`, `cdn/stories/health-issues/_${params.parentSlug}/${params['childSlug']}`, {language: locale})
            .then((s) => {
                setStory(s)
                setImgDimensions(extractImageDimensions(s.content.Picture.filename))
                setIsLoading(false)
            })
    }, [])

    useEffect(() => {
        setIsLoading(!(story && story.content))
    }, [story])

    return <>
        {!isLoading && <Helmet>
            <title>{title(story.content.Heading)}</title>
            <meta name="description" content={story.content.MetaDescription}/>
            <meta httpEquiv="content-language" content="lv"/>
        </Helmet>}
        <LatvianMetaLinksHelmet/>

        <PromocodeGiveawayPopup controls={controls}/>

        <CenteredTextualContentLayout containerClassName={"mt-2"}>
            <BackgroundWave2/>

            <Breadcrumbs className={'mb-2'}
                         localize={true}
                         items={[{
                             title: <FormattedMessage id={"pages.health-issues.title"}/>,
                             link: PublicLinks.storyblokHealthIssues()
                         }]}
                         currentPageTitle={!isLoading && story.content.Heading}/>

            {/*Heading*/}
            <div className={"pb-3 mb-0"}>
                <h1>
                    {isLoading && <HeadingPlaceholder/>}
                    {!isLoading && story.content.Heading}
                </h1>
                <BookAVisitMiniCta/>
            </div>

            {/*Picture*/}
            <div className={"mb-4"}>
                {isLoading && <div className="position-relative placeholder-wave">
                    <div className="card-img-top placeholder ratio ratio-16x9"></div>
                    <i className="ai-image position-absolute top-50 start-50 translate-middle fs-1"></i>
                </div>}
                {!isLoading && <img
                    src={story.content.Picture.filename}
                    className={"rounded-5"}
                    alt={story.content.Picture.alt || story.content.Picture.name}
                    width={imgDimensions.width}
                    height={imgDimensions.height}
                />}
            </div>

            {/*Content*/}
            <p className="pb-lg-2 mb-2 mb-lg-3">
                {isLoading && <MultipleParagraphsPlaceholder/>}
                {!isLoading && <RichText
                    content={story.content.Content}
                    headingInserter={(i) => {
                        if (i === 5) {
                            return <AboutUsBanner/>
                        }
                    }}
                />}
            </p>
        </CenteredTextualContentLayout>

        {!isLoading && story.content.Footer.map(blok => <StoryblokComponent blok={blok}/>)}
    </>
}

export let BookAVisitMiniCta = () => {
    return <div className={"bg-info-subtle px-3 py-3 rounded-3"}>
        <p className={"fs-lg mb-0"}>
            <FormattedMessage id={"pages.health-issues.cta-1.text"}/>
        </p>
        <LocalizedLink to={PublicLinks.doctors()} className={"btn ps-0 pb-0 btn-link"}
                       id={"health-issue-cta-1-button"}>
            <i className={"ms-2 ai ai-calendar-check me-2"}/>
            <FormattedMessage id={"pages.health-issues.cta-1.button"}/>
        </LocalizedLink>
    </div>
}

export default SpecificHealthIssueStoryblokPage